import ModalLinkShare from './ModalLinkShare'

export default ModalLinkShare
// eslint-disable-next-line import/export
export * from './ModalLinkShare'
